import {timer as observableTimer,  Observable } from 'rxjs';

import {take, pluck, timeInterval} from 'rxjs/operators';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';
import { FireworksComponent } from '../fireworks/fireworks.component';

@Component({
    selector: 'ep-egg-dice',
    templateUrl: './dice.component.html',
    styleUrls: ['./dice.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, FireworksComponent]
})

export class DiceComponent implements OnInit {

    constructor() { }

    showFireworks = false;
    rolling = false;
    classes = ['one', 'two', 'three', 'four', 'five', 'six'];
    currentDiceClass: string = 'six';

    ngOnInit(): void {

    }

    rollDice() {
        this.showFireworks = false;
        this.rolling = true;
        let source = observableTimer(0, 100).pipe(timeInterval(),pluck('interval'),take(30),);
        source.subscribe(
            () => {
                this.currentDiceClass = this.classes[this.getRandomIndex()];
            },
            () => {
            },
            () => {
                this.showFireworks = this.currentDiceClass == 'six';
                this.rolling = false;
                console.log('Done');
            });
    }

    getRandomIndex() {
        let min = 0;
        let max = 5;
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
}
